import { OAuthCallback } from '@/lib/auth/OAuthCallback';

/**
 * User OAuth callback handler.
 * Redirects to /dashboard on success, /login on error.
 */
export function LoginCallback() {
  return (
    <OAuthCallback
      successRedirect="/dashboard"
      errorRedirect="/login"
      callbackPath="/login/callback"
      processingKeyPrefix="auth_processing_login_"
    />
  );
}
